<template>
  <div class="rank page-content flex flex-column height-100">
    <a-row class="mobile-sticky">
      <a-col :span="24">
        <a-form class="col-12" >
            <a-row :gutter="20">
                <template v-if="!isTrainee">
                    <a-col :span="24" :md="6">
                        <a-form-item class="filter-select" label='Class'>
                            <cvc-select :options="comp_classOptions" :optionGroups="true" v-model="data_form.class" placeholder="Select class"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24" :md="12"></a-col>
                </template>
                <a-col :span="24" :md="6">
                    <a-form-item class="filter-select" label='Sort'>
                        <cvc-select :options="data_sort" v-model="data_form.sort" placeholder="Select class"  :disabled="!comp_students.length"/>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
      </a-col>
    </a-row>
    <a-row v-if="comp_students.length" class="height-100 mt3 mobile-offset mobile-card" :gutter="16">
      <a-col :span="24" class="mb2" :key="`rankLink${index}`" v-for="(student, index) in comp_studentSort">
        <a-card :class="['rank-wrapper', { 'is-student': $user.uid == student.id }]">
            <h2 class="rank-number inline left"><b>{{index+1}}</b></h2>
            <h2 class="rank-name inline left">{{ student.firstName }} {{ student.lastName }}</h2>
            <div class="rank-value inline right right-align">
                <cvc-data-block v-if="data_form.sort === 'successPercentage'" title="" :show-status="true" :status="student.total >= 80">{{ student.total }}%</cvc-data-block>
                <cvc-data-block v-else-if="data_form.sort === 'totalSuccessfulProcedures'" title="" :show-status="true" :status="!!student.total">{{ student.total }}</cvc-data-block>
                <cvc-data-block v-else-if="data_form.sort === 'totalInstantFails'" title="" :show-status="true" :status="!student.total">{{ student.total }}</cvc-data-block>
                <cvc-data-block v-else title="">{{ func_toMin(student.total) }}</cvc-data-block>
            </div>
        </a-card>
      </a-col>
    </a-row>
    <loading v-if="data_loading"/>
  </div>
</template>

<script>
import cvcSelect from '@/components/Select';
import cvcDataBlock from '@/components/DataBlock';
import { getClasses } from '@/utils/databaseUtils';
import { secToMin } from '@/utils/formatUtils';

export default {
    name: 'Tasks',
    components: {
        cvcSelect,
        cvcDataBlock
    },
    props: {
        taskOptions: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        isTrainee: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            data_loading: false,
            data_selectedClass: '',
            data_students: [],
            data_sessions: [],
            data_sort: [
                { label: 'Average time', value: 'averageTime'},
                { label: 'Last time', value: 'lastTime'},
                { label: 'Best time', value: 'bestTime'},
                { label: 'Success percentage', value: 'successPercentage'},
                { label: 'Total Successful Procedures', value: 'totalSuccessfulProcedures'},
                { label: 'Total instant fails', value: 'totalInstantFails'}
            ],
            data_form: {
                class: '',
                sort: 'averageTime'
            }
        }
    },
    methods: {
        func_toMin(sec) {
            return secToMin(sec)
        },
        func_selectFunction(option) {
            const sort = (sessions) => sessions.sort((a, b) => a.total - b.total);
            const format = {
                averageTime: {
                    sort,
                    formatter: (sessions) => sessions.reduce((averageTime, { total }) => averageTime + total, 0) / sessions.length,
                },
                lastTime: {
                    sort,
                    formatter: (sessions) => {
                        const last = sessions[sessions.length - 1];
                        return last ? last.total : 0
                    }
                },
                bestTime: {
                    sort,
                    formatter: (sessions) => sessions.reduce((best, { total }) => {
                        if (best > total && total > 0) best = total;
                        return best
                    }, 10000000)
                },
                successPercentage: {
                    sort: (sessions) => sessions.sort((a, b) => b.total - a.total),
                    formatter: (sessions) => Math.round(sessions.reduce((total, session) => total + session.percentage, 0) / sessions.length)
                },
                totalSuccessfulProcedures: {
                    sort: (sessions) => sessions.sort((a, b) => b.total - a.total),
                    formatter: (sessions) => sessions.reduce((total, session) => {
                        if (session.percentage >= 80) total++;
                        return total;
                    }, 0)
                },
                totalInstantFails: {
                    sort: (sessions) => sessions.sort((a, b) => b.total - a.total),
                    formatter: (sessions) => sessions.reduce((total, session) => total + session.fails, 0)
                }
            };
            return format[option];
        },
        func_totalTime(session) {
            return Object.keys(session.tasks).reduce((total, taskName) => {
                const currentTask = session.tasks[taskName];
                return total +  currentTask.time
            }, 0);
        },
        func_totalStats(session) {
            if (!session.tasks) return { fails: 0, passes: 0, total: 0 };
            const data = Object.keys(session.tasks).reduce((object, taskName) => {
                const currentTask = session.tasks[taskName];
                if (currentTask.status === 'incomplete') object.fails++;
                if (currentTask.status === 'complete') object.passes++;
                return object;
            }, { 
                fails: 0, 
                passes: 0, 
                total: this.func_totalTime(session), 
            });
            data.percentage = Math.round((data.passes / ( data.passes +  data.fails )) * 100);
            return data;
        },
        func_studentSessions(id) {
            return this.data_sessions.filter(({ userId }) => userId === id);
        }
    },
    computed: {
        comp_students() {
            if (!this.data_form.class) return [];
            const [year, term] = this.data_form.class.split('.');
            return Object.keys(this.comp_classes[year][term]).map(id => {
                return this.comp_classes[year][term][id]
            });
        },
        comp_classOptions() {
            return Object.keys(this.comp_classes).map((year) => {
                return { 
                    title: year, 
                    options: Object.keys(this.comp_classes[year]).map((term) => {
                        return { label: (term.charAt(0).toUpperCase() + term.slice(1)).replace(/_/g, ' '), value: term }
                    })
                };
            });
        },
        comp_classes() {
            return getClasses(this.data_students)
        },
        comp_studentSort() {
            const { formatter, sort } = this.func_selectFunction(this.data_form.sort);
            const sortData = this.comp_students.reduce((array, student) => {
                const sessions = this.func_studentSessions(student.id);
                if (sessions.length) {
                    const data = sessions.map((session) => this.func_totalStats(session));
                    const total = formatter(data);
                    array.push({...student, total });
                }
               return array;
            }, []);
            return sort(sortData);
        },
        comp_studentPassed() {
            return !this.comp_studentSessions.findIndex((session) => Object.keys(session.tasks).filter((name) => session.tasks[name].status === 'failed')) >= 1
        },
    },
    created() {
        this.data_loading = true;

        this.$services.users.getByInstitution(this.user.institution).then(({ docs }) => {
            this.data_students = docs.map(doc => ({...{id: doc.id}, ...doc.data()}));
            this.data_form.class = `${this.comp_classOptions[0].title}.${this.comp_classOptions[0].options[0].value}`;
            this.data_loading = false;
        });

        this.$services.sessions.getByInstitution(this.user.institution).then(({ docs }) => {
            this.data_sessions = docs.map(doc => ({...{id: doc.id}, ...doc.data()}));
        });
    },
}
</script>

<style lang="less">
.rank {
    .is-student {
        border: 3px solid @primary-color !important;
    }
    .rank-wrapper {
        .ant-card-body {
            padding: 0px !important;
        }
    }
    .rank-number, .rank-name, .rank-value {
        padding: 20px;
        margin: 0;
        height: 100%;
    }
    .rank-number {
        border-right: 1px solid rgba(0,0,0,0.1);
    }
    .rank-value {
        border-left: 1px solid rgba(0,0,0,0.1);
    }
    @media (max-width: 768px) {
        .rank-wrapper {
            margin: 0px -8px;
            .rank-number, .rank-name {
                font-size: 16px;
                padding-bottom: 0px;
            }
            .rank-number, .rank-value{
                border: none;
            }
            .rank-number {
                padding-right: 0px;
            }
            .rank-value {
                float: left;
                text-align: left;
                width: 100%;
            }
        }
    }
}
</style>